import { Link } from 'react-router-dom';
import { getAllCategories } from '@/lib/community';
import { SITE_NAME, SITE_TAGLINE } from '@/lib/constants';

const friendLinks = [
  { label: '开放内容协议', href: '#' },
  { label: '创作者中心', href: '#' },
  { label: '社区公约', href: '#' },
  { label: '帮助中心', href: '#' },
];

export default function Footer() {
  const categories = getAllCategories();

  return (
    <footer className="mt-16 bg-primary-100 border-t border-primary-200">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-drop-fill text-lg" />
              </span>
              <span className="font-heading font-extrabold text-lg text-foreground-900">{SITE_NAME}</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-xs">{SITE_TAGLINE}。一个多元、包容、温暖的兴趣交流社区。</p>
            <div className="mt-4 flex items-center gap-2">
              {['ri-wechat-2-line', 'ri-weibo-line', 'ri-message-3-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 rounded-md bg-background-50 text-foreground-700 flex items-center justify-center border border-primary-200"
                  aria-label="社交平台（示意）"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-label font-bold text-foreground-900 mb-4">话题分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.id}`} className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer">
                    {cat.name}讨论区
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-bold text-foreground-900 mb-4">社区导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer">搜索话题</Link>
              </li>
              <li>
                <Link to="/post" className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer">发布话题</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-bold text-foreground-900 mb-4">友情链接</h4>
            <ul className="space-y-2.5">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© 2026 {SITE_NAME} honeycommunity.cn · 本站为前端演示站点，内容仅供展示</p>
          <p className="text-xs text-foreground-600">用心分享 · 温暖相遇</p>
        </div>
      </div>
    </footer>
  );
}